module.exports = __webpack_public_path__ + "static/media/platform-tour-modal.115329ae.png";